import { useEffect } from 'react';

import OrganizationProfileForm from '../components/account-info/OrganizationProfileForm';
import { useAccount } from '../store/account/hooks';

const OrganizationProfile = () => {
  const { getAccount } = useAccount();

  useEffect(() => {
    getAccount();
  }, [getAccount]);

  return (
    <div className="relative w-full space-y-6">
      <h1 className="text-h3 dark:text-white-100">Organization Profile</h1>

      <OrganizationProfileForm />
    </div>
  );
};

export default OrganizationProfile;
